/**
 * Here we leave all "simple" options between for the i18next lib used in source files, as well as options for
 * i18next-parser (tucked in the unused `parser` key at the end). It then gets extracted and used at parser-config.js.
 * More complex options (like functions and stuff) are declared directly in utils/Locale.js, since it wasn't possible
 * to keep it all there (and duplicate options) or here.
 */

module.exports = {
	//these options effectively replace the need for a default lang file with the text being the trans key
	//see https://www.i18next.com/principles/fallback#key-fallback and https://github.com/ehungry/EHungry/wiki/Mobile-Applications#i18n-configuration
	nsSeparator     : false,
	keySeparator    : false,
	contextSeparator: ' || context => ',
	pluralSeparator : '^',

	defaultNamespace: 'translation',

	interpolation: { escapeValue: false }, //React is already XSS-safe

	//I mean... why are these true by default??
	returnNull       : false,
	returnEmptyString: false,

	//NOTE: i18next supports custom formatting functions to be abstracted, so you can configure formatters for dates and the like from outside. Might be useful in the future, so I'm leaving this note here :))
	// format: (v, format, lng) => v,

	detection: {
		order             : ['localStorage', 'navigator'],
		caches            : ['localStorage'],
		lookupLocalStorage: 'lang'
	},

	//TODO could this help us reduce the payload, loading only the necessary languages upon demand?
	// load: 'currentOnly',

	// fallbackLng: 'en-US', //this is actually defined interactively at Locale.configure()
	nonExplicitSupportedLngs: true, //considers dialects as valid if main language is supported
	// resources: locales,

	react: {
		//here we go again into another bug: parser chokes on tags https://github.com/i18next/i18next-parser/issues/264
		//FIXME actually, not sure if these options really solve any of these issues - see https://github.com/i18next/react-i18next/issues/1468
		transSupportBasicHtmlNodes: false,
		// transKeepBasicHtmlNodesFor: ['p', 'br', 'strong', 'b', 'i', 'em', 'u', 'tt', 'label']
	},

	backend: {

	},

	//this is actually extracted at parser-config.js
	parser: {
		//stores unused strings in /_old, so they can be reused automatically, or we can manually clean up later
		createOldCatalogs: true,

		//useful only if you want to know which filenames are parsed; also, remove --silent from package.json command
		// verbose: true,

		sort: true, //might be buggy, but still reduces git changes https://github.com/i18next/i18next-parser/issues/169
		lexers: { js: ['JsxLexer'] },

		//almost the same as the default, except for the src..... why there's no "outputDir" option? why these are relative to different folders? many mysteries, no answers lol
		output: "src/locales/$LOCALE/$NAMESPACE.json",
		input: ['../**/*.js'],

		defaultValue: (lang, ns, key, value) => (lang == 'en-US')? (value || key) : '',

		//if you came here looking for the list of languages available in the UI, go to Locale.#available. This is just the list of languages to generate locale files
		locales: ['en-US', 'zh-CN'] //skip en-CA since 95% of it is based on the original keys... we only translate "upon request", say. And en-US is included to serve as as translation source only.
	},

	//if you came here looking for the list of languages available in the UI, go to Locale.#available. This is just the general list of languages, it shouldn't include dialects... Although it looks like this only works without the dialects because of nonExplicitSupportedLngs
	supportedLngs: ['en','zh']
}
